<template>
  <footer class="px-4 mx-1 footer">
    <div class="row align-items-center justify-content-lg-between">
      <div class="col-lg-6">
        <div class="text-center copyright text-lg-left text-muted">
          © {{ year }}
          <a
            href="https://www.amsainfotech.com"
            class="ml-1 font-weight-bold"
            target="_blank"
            >Amsa Infotech</a
          >
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style />
